// extracted by mini-css-extract-plugin
export default {"managerInfoBlock":"ManagerInfoBlock_managerInfoBlock__tns4c","managerInfoWrapper":"ManagerInfoBlock_managerInfoWrapper__szQtw"};